import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../slices/authSlice';
import searchReducer from '../slices/searchSlice';
import autoImportReducer from '../slices/autoImportSlice';
import dashboardStatsReducer from '../slices/dashboardStatsSlice';
import credentialsReducer from '../slices/credentialsSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    search: searchReducer,
    autoImport: autoImportReducer,
    dashboardStats: dashboardStatsReducer,
    credentials: credentialsReducer,
  },
});
